'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Validator = require('validator');
var isPlainObject = require('./utils').isPlainObject;
var ERR_NAME = 'LeoricValidateError';
var LeoricValidateError = /** @class */ (function (_super) {
    __extends(LeoricValidateError, _super);
    function LeoricValidateError(validator, field, message, validateValue) {
        var _this = this;
        var errorMessage = message || "Validation ".concat(validator).concat(validateValue !== undefined ? ':' + String(validateValue) : '', " on ").concat(field, " failed");
        _this = _super.call(this, errorMessage) || this;
        _this.name = ERR_NAME;
        return _this;
    }
    return LeoricValidateError;
}(Error));
function regex(str, pattern, modifiers) {
    str += '';
    if (typeof pattern === 'string') {
        pattern = new RegExp(pattern, modifiers);
    }
    var result = str.match(pattern);
    return result ? result.length > 0 : false;
}
var validators = __assign(__assign({}, Validator), { notIn: function (str, values) {
        return !Validator.isIn(str, values);
    }, notNull: function (value) {
        return value != null;
    }, isNull: Validator.isEmpty, min: function (value, target) {
        var number = parseFloat(value);
        return isNaN(number) || number >= target;
    }, max: function (value, target) {
        var number = parseFloat(value);
        return isNaN(number) || number <= target;
    }, contains: function (str, elem) {
        return !!elem && str.includes(elem);
    }, notContains: function (str, elem) {
        return !Validator.contains(str, elem);
    }, regex: regex, notRegex: function (str, pattern, modifiers) {
        return !regex(str, pattern, modifiers);
    }, is: function (str, pattern, modifiers) {
        return regex(str, pattern, modifiers);
    }, notEmpty: function (str) {
        return /[^\s]/.test(str);
    }, len: function (str, min, max) {
        return Validator.isLength(str, min, max);
    } });
/**
 *
 * @param {Bone} ctx context
 * @param {string} name validate name
 * @param {object} attribute
 * @param {*} value
 */
function executeValidator(ctx, name, attribute, setValue) {
    var field = attribute.name, validate = attribute.validate, defaultValue = attribute.defaultValue;
    var validateArgs = validate[name];
    var value = setValue != null ? setValue : defaultValue;
    if (typeof validateArgs === 'function') {
        var needToRevert = false;
        var originValue = void 0;
        // custom validator
        try {
            // Make sure this[name] callable and not return undefined or previous value (instance only) during validator executing while updating or saving
            if (ctx.getRaw) {
                needToRevert = true;
                originValue = ctx.getRaw(field);
                ctx._setRaw(field, value);
            }
            var execRes = validateArgs.call(ctx, value);
            if (execRes === false)
                throw new LeoricValidateError(name, field);
        }
        catch (err) {
            // revert value (instance only)
            if (ctx.getRaw && needToRevert)
                ctx._setRaw(field, originValue);
            err.name = ERR_NAME;
            throw err;
        }
        // revert value (instance only)
        if (ctx.getRaw && needToRevert)
            ctx._setRaw(field, originValue);
    }
    else {
        var validator = validators[name];
        if (typeof validator !== 'function')
            throw new LeoricValidateError("Invalid validator function: ".concat(name));
        var args = validateArgs;
        var msg = void 0;
        if (isPlainObject(validateArgs)) {
            if ('args' in validateArgs)
                args = validateArgs.args;
            msg = validateArgs.msg;
        }
        if (['true', 'false'].indexOf(String(validateArgs)) >= 0) {
            if (validator.call(ctx, value == null ? value : String(value)) !== args) {
                throw new LeoricValidateError(name, field, msg, !validateArgs ? validateArgs : undefined);
            }
            return;
        }
        var callableArgs = [String(value)];
        callableArgs = callableArgs.concat(args);
        if (!validator.apply(ctx, callableArgs))
            throw new LeoricValidateError(name, field, msg);
    }
}
module.exports = {
    LeoricValidateError: LeoricValidateError,
    executeValidator: executeValidator,
};
//# sourceMappingURL=validator.js.map